var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFtm = function SvgFtm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 90 95"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m52.575 34.766 19.6-9.327v18.654zm19.6 39.972L46.042 87.174 19.908 74.738V52.975l26.134 12.436 26.133-12.436zM19.908 25.439l19.6 9.327-19.6 9.327zm29.4 13.768 19.6 9.327-19.6 9.327zm-6.533 18.654-19.6-9.327 19.6-9.327zm26.133-36.863-22.866 10.66-22.867-10.66L46.042 9.895zm-55.533-1.777v58.182l32.667 15.1 32.666-15.1V19.22l-32.666-15.1z",
    clipRule: "evenodd"
  })));
};
export default SvgFtm;